import posthog from "posthog-js";
import { PostHog as CommonPostHogInterface } from "@app/analytics/posthog";

let initialized = false;

export const PostHog: typeof CommonPostHogInterface = {
  initialize(apiKey, host) {
    if (initialized) {
      return;
    }
    posthog.init(apiKey, {
      api_host: host,
      person_profiles: "identified_only",
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      persistence: "localStorage+cookie",
    });
    initialized = true;
  },
  trackEvent(eventName, eventProperties) {
    if (!initialized) return;
    posthog.capture(eventName, eventProperties);
  },
  setUser(userId) {
    if (!initialized) return;
    if (userId) {
      posthog.identify(userId);
    } else {
      posthog.reset();
    }
  },
  setUserProperties(properties) {
    if (!initialized) return;
    posthog.setPersonProperties(properties);
  },
  getSessionId() {
    return Promise.resolve(initialized ? posthog.get_session_id() ?? "" : "");
  },
  getAnonymousId() {
    return Promise.resolve(initialized ? posthog.get_distinct_id() : null);
  },
};
